import {
  SYSTEM_ARCHITECTURE_DIAGRAMS,
  type SystemArchitectureDiagramId,
} from "./systemArchitectureRegistry";

import { VNextField } from "@/vnext/primitives";

import "./systemArchitectureCatalogue.css";

interface SystemArchitectureCatalogueProps {
  onSelect: (diagramId: SystemArchitectureDiagramId) => void;
  selectedDiagramId: SystemArchitectureDiagramId;
}

export function SystemArchitectureCatalogue({
  onSelect,
  selectedDiagramId,
}: SystemArchitectureCatalogueProps) {
  return (
    <section
      aria-labelledby="system-architecture-catalogue-heading"
      className="system-architecture-route__catalogue"
    >
      <div className="system-architecture-route__catalogue-intro">
        <div>
          <h2 id="system-architecture-catalogue-heading">
            Five views of HelloCashflow
          </h2>
          <p>Choose the level of detail that answers your question.</p>
        </div>
        <p className="system-architecture-route__reference-status">
          <strong>Current-state reference</strong>
          <span>Not live service status</span>
        </p>
      </div>

      <nav
        aria-label="Architecture views"
        className="system-architecture-route__catalogue-grid"
      >
        {SYSTEM_ARCHITECTURE_DIAGRAMS.map((diagram) => (
          <button
            aria-controls="system-architecture-diagram"
            aria-label={`${diagram.title}: ${diagram.summary}`}
            aria-pressed={diagram.id === selectedDiagramId}
            key={diagram.id}
            onClick={() => onSelect(diagram.id)}
            type="button"
          >
            <span>{diagram.level}</span>
            <strong>{diagram.title}</strong>
          </button>
        ))}
      </nav>

      <div className="system-architecture-route__catalogue-select">
        <VNextField label="Choose an architecture view">
          <select
            onChange={(event) => {
              onSelect(event.target.value as SystemArchitectureDiagramId);
            }}
            value={selectedDiagramId}
          >
            {SYSTEM_ARCHITECTURE_DIAGRAMS.map((diagram) => (
              <option key={diagram.id} value={diagram.id}>
                {diagram.title} — {diagram.level}
              </option>
            ))}
          </select>
        </VNextField>
      </div>
    </section>
  );
}
